import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import Text from '../global/Text';
import theme from '../../constants/theme';
import fontMaker from '../../utils/font';
import { NpsQuestion } from '../../store/reducers/nps/type';

const SCORES = Array.from({ length: 11 }, (_, i) => i);

type Props = {
  question: NpsQuestion;
  value: number | undefined;
  onChange: (score: number) => void;
};

const NPSQuestionScore = ({ question, value, onChange }: Props) => {
  const { t } = useTranslation('common');

  return (
    <View style={styles.root}>
      <Text style={styles.questionText}>{question.content}</Text>
      <View style={styles.scoresContainer}>
        {SCORES.map(score => {
          const selected = value === score;
          return (
            <TouchableOpacity
              key={score}
              style={[styles.scoreButton, selected && styles.scoreButtonSelected]}
              onPress={() => onChange(score)}
              activeOpacity={0.7}
            >
              <Text style={[styles.scoreText, selected && styles.scoreTextSelected]}>{score}</Text>
            </TouchableOpacity>
          );
        })}
      </View>
      <View style={styles.labels}>
        <Text style={styles.labelText}>{t('nps.notLikely')}</Text>
        <Text style={styles.labelText}>{t('nps.extremelyLikely')}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: { flex: 1, padding: 16 },
  questionText: {
    ...fontMaker({ weight: 'SemiBold' }),
    fontSize: 15,
    color: theme.colors.darkgray,
    marginBottom: 16,
    lineHeight: 22
  },
  scoresContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 8
  },
  scoreButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    borderWidth: 1.5,
    borderColor: theme.colors.primary,
    alignItems: 'center',
    justifyContent: 'center',
    margin: 4
  },
  scoreButtonSelected: {
    backgroundColor: theme.colors.primary
  },
  scoreText: {
    ...fontMaker({ weight: 'SemiBold' }),
    fontSize: 14,
    color: theme.colors.primary
  },
  scoreTextSelected: {
    color: '#fff'
  },
  labels: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 8
  },
  labelText: {
    fontSize: 11,
    color: theme.colors.gray,
    ...fontMaker({ weight: 'Normal' })
  }
});

export default NPSQuestionScore;
